export default "__VITE_ASSET__ByOmKWWc__"